module.exports = __webpack_public_path__ + "static/media/chevron-blue.7cef0eb8.svg";